/**
 * Created by Claude on 03.04.2026
 */

const AchievementsToolbarItem = function () {
    ToolbarItem.call(this, ToolbarItem.ACHIEVEMENTS);

    this.enable();

    cleverapps.achievements.on("changeAttention", this.onChangeState.bind(this), this);

    this.onChangeState();
};

AchievementsToolbarItem.prototype = Object.create(ToolbarItem.prototype);
AchievementsToolbarItem.prototype.constructor = AchievementsToolbarItem;

AchievementsToolbarItem.prototype.onChangeState = function () {
    cleverapps.achievements.hasAttention() ? this.mark() : this.unmark();
};

AchievementsToolbarItem.prototype.isVisible = function () {
    return !Achievements.hasLandmarks()
        && levels.user.checkAvailable(cleverapps.config.availables.TRAVEL_BOOK)
        && cleverapps.environment.isMainScene()
        && cleverapps.achievements.listWindowAchievements().length > 0;
};

AchievementsToolbarItem.prototype.onClick = function () {
    cleverapps.focusManager.display({
        focus: "AchievementsWindow",
        action: function (f) {
            new AchievementsWindow();
            cleverapps.focusManager.onceNoWindowsListener = f;
        }
    });
};
